import {
	sessionStorage
} from '../assets/js/storage'

const mutations = {
	SET_USER(state, user) {
		state.user = user;
		state.token = user.token;
		state.mobilePhone = user.mobilePhone || user.phoneNum;
		state.userId = user.userId;
	},
	SET_TOKEN(state, token) {
		state.token = token;
	},
	SET_Photo(state, mobilePhone) {
		state.mobilePhone = mobilePhone;
	},
	SET_CODE(state, inviteCode) {
		state.inviteCode = inviteCode;
	},
	SET_USERID(state, userId) {
		state.userId = userId;
	},
	SET_ACTLIST(state,actList){
		state.actList = actList;
	},
	SET_GENDER(state,Gender){
		state.Gender = Gender;
	} 
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js